import _lib from '../_lib';
import active from './active/index';
import {PatientNurseNavigation} from '@/store/modules/fsm/messages';

export default ({tree,parent,api}) => {
  let regionName = 'patientnurse';
  let activations = [
    {
      name: 'patientnurse',
      test: api.messageIs(PatientNurseNavigation)
    }
  ];
  let activeIndex = active;
  let func = _lib({regionName,activations,activeIndex});
  return func({tree,parent,api});
};